/**
 * CloudStore API 控制台的左侧菜单配置。
 * 每一项对应一个 history 路由页面（相对 basename=/cloudstore-api）。
 */
export interface MenuItem {
  /** 相对 basename 的路由路径 */
  path: string;
  /** 菜单显示文案 */
  label: string;
}

export const menuItems: MenuItem[] = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/original-orders", label: "Original Orders" },
  // Third-party Orders 暂时隐藏，待后续开放
  // { path: "/third-party-orders", label: "Third-party Orders" },
  { path: "/billing", label: "Billing" },
  { path: "/usage-stats", label: "Usage Stats" },
  { path: "/plan-management", label: "Plan Management" },
  { path: "/api-keys", label: "API Keys" },
  { path: "/account-settings", label: "Account Settings" },
];
